import esignTools from './controller.js';
const EsignTools = new esignTools();

export {
    EsignTools,
}